import { PerformanceTeamReviewStatusEnum } from '../enums/performance-team-review-status.enum';
import { IPerformanceTeamReviewStatus } from '../interfaces/performance-team-review-status.interface';

// @dynamic
export class PerformanceTeamReviewStatus {
    static all: IPerformanceTeamReviewStatus[] = [
        {
            name: PerformanceTeamReviewStatusEnum.IN_PROGRESS,
            translationLabel: 'GENERAL.STATUS.IN_PROGRESS',
            color: '#FFFFFF',
            bgColor: '#3774EF',
        },
        {
            name: PerformanceTeamReviewStatusEnum.COMPLETED,
            translationLabel: 'GENERAL.STATUS.COMPLETED',
            color: '#000000',
            bgColor: '#B1D42D',
        },
        {
            name: PerformanceTeamReviewStatusEnum.UPCOMING,
            translationLabel: 'GENERAL.STATUS.UPCOMING',
            color: '#000000',
            bgColor: '#FFE604',
        },
    ];
}
